import PublishingOwner from './publishingowner'

export default PublishingOwner
